var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"docScroll mb-12",attrs:{"id":"home"}},[_c('SectionColumn',{attrs:{"type":"full","content":_vm.content}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }